var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4903 8.34095L16.813 3.64682C14.9005 2.06564 12.2048 2.06564 10.2924 3.64682L4.61496 8.34095C3.59209 9.18667 3.01172 10.4689 3.01172 11.8068V19.1271C3.01172 21.5042 4.83967 23.5428 7.22809 23.5428H9.33627C10.5006 23.5428 11.4445 22.599 11.4445 21.4346V18.0065C11.4445 16.6704 12.4481 15.699 13.5526 15.699C14.6572 15.699 15.6608 16.6704 15.6608 18.0065V21.4346C15.6608 22.599 16.6047 23.5428 17.769 23.5428H19.8772C22.2657 23.5428 24.0936 21.5042 24.0936 19.1271V11.8068C24.0936 10.4689 23.5132 9.18667 22.4903 8.34095Z",
    fill: "#1570EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.6b27185ccb66e271d11ca6eef2a105b1.svg";
export { ForwardRef as ReactComponent };